import { postAction } from '@/api/manage'


//题目分割正则 匹配数字后跟着一个逗号、一个句点或者是一个<ol>标签，并且数字前面只能为换行、空格或者没有文本.
// const questionSplitReg = /(?:^|\n|\s)(\d+、|\d+，|\d+\.|\<ol\>)/g
// const questionSplitReg = /(?:^|\n|\s)(\d+、|\d+\.|\<ol\>)/g
const questionSplitReg = /(?:^|\n|\s)(\d+、|\d+\.|\(\d+\)|\<ol\>)/g
//判断题正确关键词
const rightKw = ['(对)', '（对）', '(正确)', '（正确）','对(正确答案)','对(正解)', '正确', '对','√']
//判断题错误关键词
const wrongKw = ['(错)', '（错）', '(错误)', '（错误）','错(正确答案)','错(正解)', '错误', '错', '×']
//选择题答案匹配正则,匹配()或____中的字母
const answerReg = /\(([\w\s]+)\)|（([\w\s]+)）|_{1,}([a-zA-Z]+)_{1,}/
//选择题答案替换正则,匹配()或____中的字母
const answerReplaceReg = /\(([\w\s]+)\)|（([\w\s]+)）|_{1,}([a-zA-Z]+)_{1,}/g
//阅读题题干结束关键词
const readStemEndFlag = ['\n(1)', '\n（1）', '\n1.', '\n1 .']


export const questionParseMixin = {
    data() {
        return {
            parseMethod: 0,
            questionType: 0,
            parsedQuestions: [],
            aiParseing: false,
            questionRaws: [] //分割好的题目列表
        }
    },
    watch: {
        content(val) {
            if (this.parseMethod == 0 && val) {
                this.teachingParseQuestions(val)
            }
        },
    },
    methods: {
        //解析一批题目
        aiParse() {
            if (this.questionType > 0 && this.questionRaws.length == 0) {
                this.$message.error('未识别到要解析的题目')
                return
            }
            let finishedCount = 0
            this.parsedQuestions = []
            this.aiParseing = true
            for (let i in this.questionRaws) {
                let questionRaw = this.questionRaws[i]
                this.aiParseOne(questionRaw).then(q => {
                    console.log(q);
                    this.parsedQuestions.push(q)
                    finishedCount++
                }).catch(msg=>{
                    this.$message.info(msg)
                }).finally(() => {
                    if (this.parsedQuestions.length == finishedCount) {
                        this.aiParseing = false
                    }
                })
            }
        },
        //解析一个题目
        aiParseOne(questionRaw) {
            let formData = {
                parseMethod: this.parseMethod,
                content: questionRaw,
            }
            return new Promise((resolve, reject) => {
                postAction('/teaching/teachingQuestion/aiParse', formData).then((res) => {
                    if (res.success) {
                        let q = {
                            questionName: res.result['questionName'],
                            questionStem: res.result['questionStem'],
                            questionAnswer: res.result['questionAnswer'],
                            questionType: res.result['questionType'],
                            questionScore: res.result['questionScore'],
                            questionAnalysis: res.result['questionAnalysis'],
                        }
                        if (res.result['questionOptions']) {
                            q['questionOptions'] = JSON.parse(res.result['questionOptions'])
                        }
                        resolve(q)
                    } else {
                        reject(res.message)
                    }
                })
            })
        },
        //Teaching解析
        teachingParseQuestions(text) {
            if(this.questionType == 3){
                // 阅读题限制为1个,暂不分割
                this.questionRaws = [text]
            }else{
                this.questionRaws = this.splitQuestion(text)
            }
            
            let parsedQuestions = []
            for (let i = 0; i < this.questionRaws.length; i++) {
                let questionRaw = this.questionRaws[i]
                // let questionOptionType = this.questionOptionType(questionRaw)
                let parsedQuestion = null
                if (this.questionType == 1) {
                    parsedQuestion = this.parseQuestionChoice(questionRaw)
                } else if (this.questionType == 2) {
                    parsedQuestion = this.parseQuesitonRightWrong(questionRaw)
                } else if(this.questionType == 3){
                    parsedQuestion = this.parseQuestionRead(questionRaw)
                }else {
                    console.log('无法识别选项类型')
                }
                if (parsedQuestion != null) {
                    console.log('解析到题目：')
                    console.log(parsedQuestion)
                    parsedQuestions.push(parsedQuestion)
                }
            }
            this.parsedQuestions = parsedQuestions
            console.log(this.parsedQuestions)
        },
        //解析阅读题
        parseQuestionRead(questionRaw){
            console.log('解析阅读题')
            let parsedReadQuestion = {
                raw: questionRaw,
                questionAnswer: [],
                questionOptions: [],
                questionType: 6,
                questionScore: 0,
            }
            //解析题干
            let stemEndIndex = -1
            for(let i=0; i<readStemEndFlag.length; i++){
                // console.log(readStemEndFlag[i], questionRaw.indexOf(readStemEndFlag[i]));
                if(questionRaw.indexOf(readStemEndFlag[i]) > 20){
                    stemEndIndex = questionRaw.indexOf(readStemEndFlag[i])
                    break
                }
            }
            if(stemEndIndex > 0){
                parsedReadQuestion['questionStem'] = questionRaw.slice(0, stemEndIndex)
            }else{
                return null
            }
            console.log("questionStem", parsedReadQuestion['questionStem']);
            //解析子问题
            let subQuestionRaw = questionRaw.slice(stemEndIndex)
            let subQuestions = this.splitQuestion(subQuestionRaw)
            for (let i = 0; i < subQuestions.length; i++) {
                let subQuestionRaw = subQuestions[i]
                console.log("subQuestionRaw", subQuestionRaw);
                let parsedSubQuestion = this.parseQuestionChoice(subQuestionRaw)
                console.log("parsedSubQuestion", parsedSubQuestion);

                //构建子问题
                let questionOptions = {
                    stem: parsedSubQuestion['questionStem'],
                    type: 1,
                    score: 5,
                    options: parsedSubQuestion['questionOptions']
                }
                parsedReadQuestion['questionScore'] += questionOptions.score
                parsedReadQuestion['questionOptions'].push(questionOptions)
                //子问题答案
                parsedReadQuestion.questionAnswer.push(parsedSubQuestion.questionAnswer)
            }

            console.log(parsedReadQuestion);
            return parsedReadQuestion
        },
        //解析选择题
        parseQuestionChoice(questionRaw) {
            console.log('解析选择题')
            let parsedQuestion = {
                raw: questionRaw,
                questionAnswer: '',
                questionOptions: '',
                questionType: '',
                questionScore: 1,
            }
            //解析答案
            let answerMatch = questionRaw.match(answerReg)
            if (answerMatch) {
                let answer = answerMatch[1] || answerMatch[2] || answerMatch[3]
                console.log(answerMatch, answer)
                if (answer) {
                    answer = answer.trim()
                    answer = answer.replaceAll(' ', '')
                    if (answer.length == 1) {
                        parsedQuestion['questionAnswer'] = this.letter2index(answer)
                        parsedQuestion['questionType'] = 1
                        parsedQuestion['questionScore'] = 2
                    } else if (answer.length > 1) {
                        parsedQuestion['questionAnswer'] = this.letters2indexs(answer)
                        parsedQuestion['questionType'] = 2
                        parsedQuestion['questionScore'] = 5
                    } else {
                        // 没有答案
                    }
                }
            }
            //解析选项
            let options = []
            let indexA = this.getLasetIndexOf(questionRaw, 'A')
            let indexB = this.getLasetIndexOf(questionRaw, 'B')
            let indexC = this.getLasetIndexOf(questionRaw, 'C')
            let indexD = this.getLasetIndexOf(questionRaw, 'D')
            if (indexA > -1 && indexB > -1 && indexA < indexB) {
                //ABCD的选项格式
                let a,
                    b,
                    c,
                    d = ''
                a = questionRaw.substring(indexA, indexB)
                if (indexC > -1 && indexC > indexB) {
                    b = questionRaw.substring(indexB, indexC)
                } else {
                    b = questionRaw.substring(indexB)
                }
                if (indexD > -1 && indexD > indexC) {
                    c = questionRaw.substring(indexC, indexD)
                    d = questionRaw.substring(indexD)
                } else if (indexC > -1) {
                    c = questionRaw.substring(indexC)
                }
                if (a) options.push({ item: a })
                if (b) options.push({ item: b })
                if (c) options.push({ item: c })
                if (d) options.push({ item: d })
                //格式化选项
                for (let oi in options) {
                    let o = options[oi]
                    o.index = o.item.substring(0, 1)
                    o.item = o.item.substring(1) //去除选项字母
                    o.item = o.item.trim()
                    if (o.item.startsWith(' ') || o.item.startsWith('、') || o.item.startsWith('.') || o.item.startsWith(':') || o.item.startsWith('：')) {
                        o.item = o.item.substring(1) //去除选项字母后缀
                    }
                    o.item = o.item.trim()
                }
                parsedQuestion['questionOptions'] = options
                if(parsedQuestion['questionType'] === '') parsedQuestion['questionType'] = 1
            }
            //选项形式的判断题型
            if (parsedQuestion['questionAnswer'] !== '' && parsedQuestion['questionOptions'].length == 2) {
                console.log("选项形式的判断题型",parsedQuestion['questionAnswer'],parsedQuestion['questionOptions'] );
                let a = 'false'
                for (let oi in parsedQuestion['questionOptions']) {
                    let o = parsedQuestion['questionOptions'][oi]
                    if (
                        parsedQuestion['questionAnswer'] == this.letter2index(o.index) &&
                        (o.item.includes('正确') || o.item.includes('对') || o.item.includes('√'))
                    ) {
                        a = 'true'
                    }
                }
                parsedQuestion['questionAnswer'] = a
                parsedQuestion['questionOptions'] = ''
                parsedQuestion['questionType'] = 3
                parsedQuestion['questionScore'] = 2
            }
            //解析题干
            let questionStem = questionRaw.substring(0, indexA)
            questionStem = questionStem.replaceAll(answerReplaceReg, '( )') //剔除题干中的正确答案
            questionStem = questionStem.trim()
            parsedQuestion['questionStem'] = questionStem
            return parsedQuestion
        },
        //解析判断题
        parseQuesitonRightWrong(questionRaw) {
            console.log('解析判断题')
            let parsedQuestion = {
                raw: questionRaw,
                questionType: 3,
                questionAnswer: '',
                questionOptions: '',
                questionScore: 1
            }
            //倒序查找最后一个答案
            let answerIndex = -1
            for (let i=wrongKw.length;i>=0;i--) {
                let k = wrongKw[i]
                console.log(k);
                if (questionRaw.lastIndexOf(k)>-1) {
                    console.log(k);
                    parsedQuestion['questionAnswer'] = 'false'
                    answerIndex = questionRaw.lastIndexOf(k)
                    break
                }
            }
            for (let i=rightKw.length;i>=0;i--) {
                let k = rightKw[i]
                if (questionRaw.lastIndexOf(k)>-1) {
                    console.log(k);
                    parsedQuestion['questionAnswer'] = 'true'
                    answerIndex = questionRaw.lastIndexOf(k)
                    break
                }
            }
            if(answerIndex > -1){
                questionRaw  = questionRaw.slice(0,answerIndex) + ' ' + questionRaw.slice(answerIndex+1)
            }
            parsedQuestion['questionStem'] = questionRaw
            return parsedQuestion
        },
        // 判断题目类型 0未识别 1选择题  2判断题
        questionOptionType(questionRaw) {
            let indexA = this.getLasetIndexOf(questionRaw, 'A')
            let indexB = this.getLasetIndexOf(questionRaw, 'B')
            console.log("type", indexA, indexB);
            if (indexA > -1 && indexB > -1 && indexA < indexB) {
                return 1
            }
            let kw = rightKw.concat(wrongKw)
            for (let k of kw) {
                if (questionRaw.includes(k)) {
                    return 2
                }
            }
            return 0
        },
        //选项字母文本最后出现的位置
        getLasetIndexOf(text, letter){
            if(text.lastIndexOf(letter+'、') > -1){
                return text.lastIndexOf(letter+'、')
            }
            if(text.lastIndexOf(letter+'.') > -1){
                return text.lastIndexOf(letter+'.')
            }
            return text.lastIndexOf(letter)
        },
        //分割题目
        splitQuestion(text) {
            let raw = text
            raw = raw.replaceAll('&nbsp;', ' ') //空格转换
            raw = raw.replaceAll('<p>', '\n') //p标签转为换行
            raw = raw.replaceAll('</p>', '\n')
            raw = raw.replace(/<span[^>]*>([^<]+)<\/span>/g, '$1')//去掉span标签

            let questionRaws = []
            if (raw.match(questionSplitReg)) {
                questionRaws = raw.split(questionSplitReg)
            } else if (raw.includes('\n\n')) {
                questionRaws = raw.split('\n\n')
            }else{
                questionRaws.push(raw)
            }
            let questions = []
            for (let i in questionRaws) {
                let q = questionRaws[i]
                //过滤字数很少的
                if (q.length < 10) {
                    continue
                }
                //过滤table html
                q = q.replaceAll('<ol>', '')
                q = q.replaceAll('</ol>', '')
                q = q.replaceAll('<li>', '')
                q = q.replaceAll('</li>', '')
                q = q.trim()
                questions.push(q)
            }
            console.log("已分割题目", questions.length);
            return questions
        },
        //字母转索引
        letter2index(letter) {
            if (letter.charCodeAt() < 65 || letter.charCodeAt() > 90) {
                return -1
            }
            return letter.charCodeAt() - 65
        },
        //索引转大写字母
        index2letter(index) {
            if (index < 0 || index > 25) {
                return ''
            }
            return String.fromCharCode(65 + index)
        },
        //多个字母转索引json
        letters2indexs(letters) {
            let ls = letters.split('')
            let indexs = []
            for (let l of ls) {
                indexs.push(this.letter2index(l))
            }
            console.log(indexs);
            return indexs
        },
        //多个索引转字母
        indexs2letters(indexs) {

        }
    }
}